<template>
  <div v-if="content" class="faq">
    <ul>
      <li v-for="(category, i) in content.categories" :key="i">
        <div
          :style="{ backgroundColor: category.bg_color ? category.bg_color.color : '', color: category.color ? category.color.color : ''}"
          class="category-header"
          @click="toggleVisibility(i)"
        >
          <fai class="icon" v-if="category.icon" :icon="getIcon(category.icon)"></fai>
          <h4>{{category.title}}</h4>
          <fai class="icon" :icon="i === currentCategory ? 'chevron-up' : 'chevron-down'"></fai>
        </div>
        <div class="category-content" :class="i === currentCategory ? 'active' : ''">
          <ul>
            <li v-for="(question, j) in category.questions" :key="i + '_' + j">
              <div class="question">{{question.question}}</div>
              <div class="response">
                <vue-markdown class="markdown">{{question.response}}</vue-markdown>
              </div>
            </li>
          </ul>
          <div>
            <component :content="blok" :key="blok._uid" v-for="blok in category.data" :is="blok.component"></component>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    content: null,
  },
  data() {
    return {
      currentCategory: -1,
    };
  },
  methods: {
    getIcon(icon) {
      if (icon) {
        return icon.icon.replace("fa-", "");
      }
    },
    toggleVisibility(i) {
      if (i === this.currentCategory) {
        this.currentCategory = -1;
      } else {
        this.currentCategory = i;
      }
    },
  },
};
</script>

<style lang="scss">
.faq {
  max-width: $max-width;
  width: 1200px;
  margin: 30px auto;

  > ul {
    > li {
      box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
      overflow: hidden;
      margin-bottom: 30px;
      background: #f5f5f5;
      .category-header {
        padding: 25px 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        gap: 15px;
        h4 {
          font-weight: bold;
          font-size: 22px;
          flex: 1;
        }
      }
      .category-content {
        display: none;
        padding-top: 35px;
        &.active {
          display: block;
        }
        .question {
          font-weight: bold;
          padding-bottom: 15px;
        }
        .response {
          padding-bottom: 30px;
          line-height: 1.5;
        }
      }
    }
  }
}
</style>
